import { createContext, useContext } from 'react';
import { noop } from 'lodash';

import { JabraFocusItemElement } from './JabraFocus.model';

export type NavigationMode = 'vertical' | 'horizontal' | 'both';

export interface IJabraFocusGroupContext {
  moveFocus: (delta: number) => boolean;
  registerItem: (item: JabraFocusItemElement) => void;
  setFocused: (id: string) => void;
  unregisterItem: (id: string) => void;
  focused?: string;
  items: JabraFocusItemElement[];
  orientation: NavigationMode;
  parentId?: string;
}

export const JabraFocusContext = createContext<IJabraFocusGroupContext>({
  moveFocus: () => false,
  items: [],
  registerItem: noop,
  setFocused: noop,
  unregisterItem: noop,
  orientation: 'both',
});

export const useFocusContext = (): IJabraFocusGroupContext => {
  return useContext(JabraFocusContext);
};
